import React from 'react'
import { Container, Flex } from '@chakra-ui/react'
import ShopFilter from '@components/shop/shop-filter'
import { UseFilterProductsReturn } from '@common/hooks/use-filter-product'
import BodyLayout from './body-layout'
import ListProduct from '@components/product/list-product'
import Pagination from '@components/pagination'
import LinkTextUnderline from '@components/link-text-underline'
import { useResponsive } from '@common/hooks'
import { ProductPreviewType } from 'types/global'
import useFilterQueryParams from '@common/hooks/use-filter-query-param'
import HeadingTag from '@components/heading-tag'
import useAosAnimation from '@common/hooks/use-aos-animation'
interface UserFilterType extends UseFilterProductsReturn {
  hides: string[]
}

interface ShopLayoutPropsType {
  textHeader?: string
  useFilter: UserFilterType
  isPagination?: boolean
  isViewMore?: boolean
  items?: ProductPreviewType[]
  loading?: boolean
  totalPage?: number
}

const ShopLayout: React.FC<ShopLayoutPropsType> = ({
  textHeader,
  useFilter,
  isPagination,
  isViewMore,
  items,
  loading,
  totalPage
}) => {
  const { smMax } = useResponsive()

  const { addPage } = useFilterQueryParams()

  const {
    filter,
    hides,
    currentPage,
    setCurrentPage,
    limit,
    isLoading,
    listItemsViewMore,
    listItems,
    dataFilter
  } = useFilter

  isPagination =
    isPagination != null
      ? isPagination
      : dataFilter != null &&
        dataFilter.products?.length > 0 &&
        // totalProduct != null &&
        // totalProduct?.length > 0 &&
        !filter.allProductsOnePage &&
        !smMax

  isViewMore =
    isViewMore != null
      ? isViewMore
      : dataFilter != null &&
        dataFilter.products?.length > 0 &&
        // totalProduct != null &&
        // totalProduct?.length > 0 &&
        !filter.allProductsOnePage &&
        smMax

  items = items != null ? items : smMax ? listItemsViewMore : listItems

  loading = loading != null ? loading : isLoading

  totalPage = totalPage != null ? totalPage : dataFilter?.count ?? 0

  useAosAnimation({
    duration: 600,
    once: true
  })

  return (
    <Container mb={28} mt={14}>
      {textHeader && (
        <HeadingTag style={{ textAlign: 'center' }} data-aos="fade-down">
          {textHeader}
        </HeadingTag>
      )}
      <BodyLayout>
        <ShopFilter hides={hides} />
        <ListProduct items={items ?? []} isLoading={loading} />
        {isPagination && (
          <Flex justifyContent={'center'}>
            <Pagination
              currentPage={currentPage}
              totalCount={totalPage}
              pageSize={limit}
              setCurrentPage={(input: number) => {
                addPage(input)
              }}
            />
          </Flex>
        )}
      </BodyLayout>
      {isViewMore && (
        <Flex justifyContent={'center'} mt={0}>
          <LinkTextUnderline
            textStyle={'viewMoreText'}
            text={'View More'}
            color={'black'}
            onClick={() => {
              setCurrentPage(currentPage + 1)
            }}
          />
        </Flex>
      )}
    </Container>
  )
}

export default ShopLayout
